import type { WorkerAPI } from "@pdfking/compatibility"

import { WORKER_MARKER } from "../../internal/WorkerMarker"

const internalCreateWorker = <T, R>(worker: {
  onmessage: ((event: MessageEvent) => void) | null
  postMessage: (message: unknown) => void
}): WorkerAPI<T, R> => ({
  on: (handler: (data: any) => void) =>
    (worker.onmessage = (event: MessageEvent) => handler(event.data)),
  send: (message: any) => worker.postMessage(message),
})

export const CreateWorker = <T, R>(path: string | URL): WorkerAPI<T, R> => {
  console.info("creating worker", path)
  const worker = new Worker(path, { name: WORKER_MARKER, type: "module" })
  worker.onerror = console.error
  return internalCreateWorker(worker)
}

export const CreateWorkerFromSelf = <T, R>(): WorkerAPI<T, R> => internalCreateWorker(self)
